import { render } from "./ManageRiskRegisterModal.vue?vue&type=template&id=97f43c14&scoped=true"
import script from "./ManageRiskRegisterModal.js?vue&type=script&lang=js"
export * from "./ManageRiskRegisterModal.js?vue&type=script&lang=js"

import "./ManageRiskRegisterModal.vue?vue&type=style&index=0&id=97f43c14&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f43c14"]])

export default __exports__